
define(
	'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.Checkout'
,   [
		'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.Utility',
		'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.View'
	]
,   function (
		MyAccountStandaloneUtility,
		MyAccountStandaloneView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {

			var loginRegister;
			var environment;
			var layout;
			var userProfile;
			var siteSettings;
			var config;
			var view;
			var viewShown;
			var standaloneViews;

			loginRegister = container.getComponent('LoginRegisterPage');
			environment = container.getComponent('Environment');
			layout = container.getComponent('Layout');
			userProfile = container.getComponent('UserProfile');

			config = environment.getConfig('digiConfigSettings.digiMyAccountStandalone');
			siteSettings = environment.getSiteSetting();

			if (config && config.enabled) {

				if(loginRegister) {

					loginRegister.on('beforeLogin', function () {

						var origUrl;
						var hashSplit;
						var newUrl;

						origUrl = location.href;
						hashSplit = origUrl.split('#');

						if (hashSplit && hashSplit.length) {
							newUrl = hashSplit[0] + '&origin=customercenter' + ('#' + hashSplit[1] || '');
							window.history.replaceState({}, '', newUrl);
						}
					});
				}

				var myAccountTouchPoint = siteSettings && siteSettings.touchpoints && siteSettings.touchpoints.customercenter;

				view = new MyAccountStandaloneView({
					redirect: myAccountTouchPoint
				});

				if (layout) {

					standaloneViews = [
						'Header.View',
						'Header.Menu.View',
						'Header.Profile.View'
					];
	
					if (layout) {
	
						_.each(standaloneViews, function (view) {
							MyAccountStandaloneUtility.showAsStandalone(layout, view);
						});
	
						MyAccountStandaloneUtility.hideSearch(layout, environment);
					}

					layout.on('afterShowContent', function () {

						userProfile.getUserProfile().done(function (user) {
							if (myAccountTouchPoint && user && user.isloggedin) {
								if (!viewShown) {
									layout.showContent(view, {});
									viewShown= true;
								}
							}
						});
					});
				}
			}
		}
	};
});
